document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sticky-add-to-cart]').forEach(function (bar) {
    var sectionId = bar.dataset.section;
    var watchButton = document.getElementById(bar.dataset.watch);
    var sourcePrice = document.getElementById(bar.dataset.sourcePrice);
    var sourceButton = document.getElementById(bar.dataset.sourceButton);
    var stickyPrice = document.getElementById('StickyPrice-' + sectionId);
    var stickyButton = document.getElementById('StickySubmitButton-' + sectionId);

    if (!watchButton || !stickyButton) return;

    bar.hidden = false;

    // Reveal only after the in-page Add to Cart button has scrolled out of view,
    // so the bar "follows the thumb" instead of duplicating a button already
    // on screen.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.removeAttribute('data-visible');
            } else {
              bar.setAttribute('data-visible', '');
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(watchButton);
    } else {
      bar.setAttribute('data-visible', '');
    }

    // Keep price + sold-out/disabled state in sync with the real form as the
    // shopper changes size / dress style.
    function syncFromSource() {
      if (sourcePrice && stickyPrice) {
        stickyPrice.innerHTML = sourcePrice.innerHTML;
      }
      if (sourceButton && stickyButton) {
        stickyButton.disabled = sourceButton.disabled;
        var label = sourceButton.querySelector('span');
        var stickyLabel = stickyButton.querySelector('span');
        if (label && stickyLabel) {
          stickyLabel.textContent = label.textContent.trim();
        }
      }
    }

    syncFromSource();

    if (sourcePrice && 'MutationObserver' in window) {
      new MutationObserver(syncFromSource).observe(sourcePrice, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
    if (sourceButton && 'MutationObserver' in window) {
      new MutationObserver(syncFromSource).observe(sourceButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
      });
    }
  });
});
